export default {
    ROUTES: {
        CANCEL_TRIP: 'cancel',
        EDIT_TRIP_DELAY: 'delay',
        COPY_TRIP: 'copy',
        SKIP_STOP: 'skip',
        CHANGE_STOP: 'change',
        ADVANCER: 'advancer',
        VIEW_TRIP: 'view',
        RECURRENT_CANCEL: 'recurrent_cancel',
        UPDATE_HEADSIGN: 'update_headsign',
        HIDE_TRIP: 'hide',
        NEW_TRIP: 'new',
        HIDE_STOP: 'hide',
        EDIT_OPERATION_NOTES: 'operation_notes',
    },
    BLOCKS: {
        ADD_BLOCK: 'add',
        EDIT_BLOCK: 'edit',
    },
    STOP_MESSAGING: {
        EDIT_STOP_MESSAGE: 'edit',
    },
    DISRUPTIONS: {
        ADD_DISRUPTION: 'add',
        EDIT_DISRUPTION: 'edit',
    },
    ALERTS: {
        DISMISS_ALERT: 'dismiss',
    },
    NOTIFICATIONS: {
        EDIT_NOTIFICATION: 'edit',
        VIEW_NOTIFICATION: 'view',
    },
    RECURRING_CANCELLATIONS: {
        UPDATE_RECURRING_CANCELLATIONS: 'recurrent_cancel',
    },
    DATA_MANAGEMENT_BUS_PRIORITY: {
        EDIT_BUS_PRIORITY: 'edit',
        VIEW_BUS_PRIORITY: 'view',
    },
};
